import { Flex, IconButton, Text } from '@radix-ui/themes';
import React, { useState } from 'react';
import { MdOutlineEdit, MdOutlineVerifiedUser, MdGroups } from 'react-icons/md';
import { VscUnverified, VscVerified } from 'react-icons/vsc';
import { useParams, useOutletContext } from 'react-router-dom';
import TableComponent from '../components/ui-components/TableComponent';
import ViewUser from '../components/ui-components/ViewUser';
import CreateUser from '../components/ui-components/CreateUser';
import ViewCaregivers from '../components/ui-components/ViewCaregivers';

const UserList = () => {
  const { user_type } = useParams();
  const activeUserType = user_type || 'department';
  const roleId = localStorage.getItem('roleId');
  
  // Get data and helpers from the parent (UsersPage)
  const { users, fetchUsers, showToast, currentPage, pageSize } = useOutletContext();
  
  const [editUser, setEditUser] = useState(null);

  // Add serial number to user data based on current page and page size
  const usersWithSerial = users.map((user, index) => ({
    ...user,
    serialNumber: (currentPage - 1) * pageSize + index + 1,
  }));

  const getDepartmentColumns = () => [
    {
      title: 'Sl No',
      key: 'serialNumber',
      render: (value) => <Text size={2}>{value}</Text>,
    },
    {
      title: 'Department',
      key: 'firstName', // 'firstName' holds the department name for this role
      render: (value) => <Text>{value}</Text>,
    },
    {
      title: 'User Name',
      key: 'userName',
      render: (value) => <Text>{value}</Text>,
    },
     {
      title: 'Email',
      key: 'email',
      render: (value, row) => (
        <span className="flex items-center gap-1">
          {value || 'N/A'}
          {row.isEmailConfirmed ? <VscVerified color="green" /> : <VscUnverified color="tomato" />}
        </span>
      ),
    },
    {
      title: 'Status',
      key: 'isActive',
      render: (value) => (
        <Flex align="center" gap="1">
          <MdOutlineVerifiedUser color={value ? 'green' : 'red'} />
          <span style={{ color: value ? 'green' : 'tomato' }}>{value ? 'Active' : 'Inactive'}</span>
        </Flex>
      ),
    },
    {
      title: 'Caregivers',
      key: 'caregivers',
      render: (_, row) => (
        <ViewCaregivers
          department={row}
          triggerButton={
            <IconButton variant="ghost" color="blue" title="View Caregivers">
              <MdGroups size={20} />
            </IconButton>
          }
        />
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, row) => (
        <Flex gap={'2'} align={'center'}>
          <IconButton variant="outline" onClick={() => setEditUser(row)}>
            <MdOutlineEdit size={18} />
          </IconButton>
          <ViewUser initialValues={row} onActionSuccess={fetchUsers} />
        </Flex>
      ),
    },
  ];

  const getDefaultColumns = () => [
    {
      title: 'Sl No',
      key: 'serialNumber',
      render: (value) => <Text size={2}>{value}</Text>,
    },
    {
      title: 'User Name',
      key: 'userName',
      render: (value) => <Text >{value}</Text>,
    },
        {
      title: 'Email',
      key: 'email',
      render: (value, row) => (
          <span className="flex items-center gap-1">
          {value || 'N/A'}
          {row.isEmailConfirmed ? <VscVerified color="green" /> : <VscUnverified color="tomato" />}
          </span>
      ),
    },
    {
      title: 'Status',
      key: 'isActive',
      render: (value) => (
          <Flex align="center" gap="1">
          <MdOutlineVerifiedUser color={value ? 'green' : 'red'} />
          <span style={{ color: value ? 'green' : 'tomato' }}>{value ? 'Active' : 'Inactive'}</span>
          </Flex>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, row) => (
          <Flex gap={'2'} align={'center'}>
              <IconButton variant="outline" onClick={() => setEditUser(row)}>
                  <MdOutlineEdit size={18} />
              </IconButton>
              <ViewUser initialValues={row} onActionSuccess={fetchUsers} />
          </Flex>
      ),
    },
  ];

  const handleCloseEdit = () => {
    setEditUser(null);
  };

  const columns = activeUserType === 'department' ? getDepartmentColumns() : getDefaultColumns();

  return (
    <div>
      {usersWithSerial.length > 0 ? (
        <TableComponent dataStructure={usersWithSerial} columns={columns} />
      ) : (
        <div className="text-center p-8 text-gray-500">
          No {activeUserType} users found
        </div>
      )}
      
      {editUser && (
        <CreateUser
          initialValues={editUser}
          roleId={roleId}
          onUserCreated={() => {
            fetchUsers();
            handleCloseEdit();
          }}
          onClose={handleCloseEdit}
        />
      )}
    </div>
  );
};

export default UserList;
